import React from 'react';
import { useValueWithDeferredDispatch } from '../../services/modelInteraction';
import Input from '../../shared/ui/Input';

const ModelSearch = ({ selector, createAction, delay }) => {
  const [value, setValue] = useValueWithDeferredDispatch({
    selector,
    createAction,
    delay,
  });

  return (
    <Input
      value={value}
      onChange={(e) => setValue(e.target.value)}
      type={Input.types.search}
    />
  );
};

export default ModelSearch;
